import { useMemo } from "react";
import { Plus } from "lucide-react";

import { Button } from "@/components/ui/button";
import MultiSelectFilter from "@/components/sections/financeiro/extrato/MultiSelectFilter";

// FIN-5 — CategoriasToolbar.
// Esquerda: AccountFilterDropdown (reusa MultiSelectFilter da FIN-2).
// Direita: botão "+ Nova categoria".

export default function CategoriasToolbar({
  accounts,
  accountIds,
  onChangeAccountIds,
  onCreate,
}) {
  const accountOptions = useMemo(() => (
    (accounts || []).filter(a => !a.deleted_at).map(a => ({
      value: a.id,
      label: a.name,
      tone: a.type,
    }))
  ), [accounts]);

  return (
    <div
      className="flex flex-col md:flex-row md:items-center md:justify-between gap-3"
      data-testid="cat-toolbar"
    >
      <MultiSelectFilter
        label="Contas"
        placeholder="Buscar conta..."
        options={accountOptions}
        selected={accountIds || []}
        onChange={onChangeAccountIds}
        searchable={accountOptions.length > 6}
        testId="cat-filter-accounts"
      />

      <Button variant="primary" size="md" onClick={onCreate} data-testid="cat-create-btn">
        <Plus className="w-4 h-4" />
        Nova categoria
      </Button>
    </div>
  );
}
